<template>
    <div>
        <v-navigation-drawer
        v-model="drawer"
        app
        clipped
        >

        <v-list dense>
            <v-list-item @click="pushTo('profil')">
                    <v-list-item-avatar color="pink">#</v-list-item-avatar>
                    <v-list-item-title>{{this.$store.state.loginAs.data.username}}</v-list-item-title>            
            </v-list-item>
            <v-divider class="mt-2 mb-2"></v-divider>

            <v-list-item
            v-for="item in items"
            :key="item.text"
            @click="pushTo(item.act)"
            >
                <v-list-item-action>
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                    {{ item.text }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
           
            
        </v-list>
        </v-navigation-drawer>

        <v-app-bar
        app
        color="pink darken-2"
        dark
        clipped-left
        >
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title>Sweetes</v-toolbar-title>
        
        <v-spacer></v-spacer>
        
        </v-app-bar>

    </div>
</template>

<script>
export default {
    data: () => ({
      drawer: null,
      items: [
        { icon: 'dashboard', text: 'Beranda', act: 'beranda' },
        // { icon: 'brightness_medium', text: 'Toggle Theme', act: 'toggleTheme' },
        { icon: 'logout', text: 'Logout', act: 'logout' },
      ],
      items2: [
        // { picture: 28, text: 'Joseph' },
        // { picture: 38, text: 'Apple' },
        // { picture: 48, text: 'Xbox Ahoy' },
        // { picture: 58, text: 'Nokia' },
        // { picture: 78, text: 'MKBHD' },
      ],
    }),
    methods: {
        pushTo (act) {
            if (act == 'logout') {
                this.$store.commit('logout');
            }else if (act == 'profil') {
                this.$router.push('/user/'+this.$store.state.loginAs.user_id);
            }else if (act == 'toggleTheme') {
                this.$store.commit('toggleTheme');
            }else if (act == 'beranda') {
                this.$router.push('/');
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Appbar.vue